import type { SVGProps } from "react"

export default function ArrowDown(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="19"
      height="9"
      viewBox="0 0 19 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.25 0.75L9.5 8.25L0.75 0.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
